// extracted by mini-css-extract-plugin
export default {"root":"Pagintion_root__uhlmP"};